import { useState } from "react";

interface Props {
  onLogin: () => void;
}

const ADMIN_EMAIL = "admin@thorpedellow.com";
const ADMIN_PASSWORD = "Bellucci123@!@";

export default function AdminLogin({ onLogin }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    await new Promise((r) => setTimeout(r, 600));

    if (email.trim().toLowerCase() === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
      sessionStorage.setItem("td_admin_auth", "1");
      onLogin();
    } else {
      setError("Invalid email or password. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "linear-gradient(135deg, #071A2E 0%, #0D2B4A 60%, #071A2E 100%)" }}
    >
      {/* Background glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse at 50% 40%, rgba(201,168,76,0.08) 0%, transparent 65%)" }}
      />

      <div className="relative w-full max-w-md">
        {/* Gold top line */}
        <div
          className="h-[2px] w-full rounded-t-2xl"
          style={{ background: "linear-gradient(90deg, transparent, #C9A84C 30%, #E2C27A 50%, #C9A84C 70%, transparent)" }}
        />

        <div className="bg-white rounded-b-2xl overflow-hidden">
          {/* Header */}
          <div className="px-8 pt-10 pb-8 text-center border-b border-slate-100">
            <div
              className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-5 border border-[#C9A84C]/40"
              style={{ background: "linear-gradient(135deg, #071A2E 0%, #0D2B4A 100%)", boxShadow: "0 0 24px rgba(201,168,76,0.2)" }}
            >
              <i className="ri-home-4-fill text-[#C9A84C] text-2xl leading-none" />
            </div>
            <h1
              className="text-xl font-bold text-[#071A2E] mb-1"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Thorpe Dellow
            </h1>
            <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-[0.2em]">Admin Panel</p>
            <p className="text-slate-400 text-xs mt-2">Sign in to manage your website content</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="px-8 py-8 space-y-5">
            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1.5">Email Address</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-slate-400">
                  <i className="ri-mail-line text-sm leading-none" />
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="admin@thorpedellow.com"
                  className="w-full pl-9 pr-4 py-3 border border-slate-200 rounded-xl text-sm text-slate-700 focus:outline-none focus:border-[#C9A84C] transition-colors bg-slate-50"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-600 mb-1.5">Password</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-slate-400">
                  <i className="ri-lock-2-line text-sm leading-none" />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••••••"
                  className="w-full pl-9 pr-10 py-3 border border-slate-200 rounded-xl text-sm text-slate-700 focus:outline-none focus:border-[#C9A84C] transition-colors bg-slate-50"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-slate-400 hover:text-slate-600 cursor-pointer"
                >
                  <i className={`${showPassword ? "ri-eye-off-line" : "ri-eye-line"} text-sm leading-none`} />
                </button>
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                <div className="w-4 h-4 flex items-center justify-center text-red-500 flex-shrink-0">
                  <i className="ri-error-warning-line text-sm leading-none" />
                </div>
                <p className="text-red-600 text-xs">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 rounded-xl text-sm font-bold uppercase tracking-wide transition-all cursor-pointer disabled:opacity-60 flex items-center justify-center gap-2 whitespace-nowrap"
              style={{ background: "linear-gradient(135deg, #C9A84C 0%, #E2C27A 50%, #C9A84C 100%)", color: "#071A2E" }}
            >
              {loading ? (
                <><i className="ri-loader-4-line animate-spin leading-none" /> Signing in...</>
              ) : (
                <><i className="ri-login-box-line leading-none" /> Sign In to Admin</>
              )}
            </button>
          </form>

          {/* Footer */}
          <div className="px-8 pb-6 text-center">
            <p className="text-[10px] text-slate-400 leading-relaxed">
              Thorpe Property Development Ltd · Company No. 07590563<br />
              Authorised access only. All activity is logged.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
